/**
 * Turns a plain Enter into a `c-text-editor:submit` host event instead of a
 * paragraph split — for single-message inputs like the thread chat box.
 * Shift+Enter still inserts a line break via the default keymap.
 *
 * IMPORTANT: list this extension FIRST in the editor's extension list.
 * Later extensions get higher keydown priority, so the popup menus
 * (inline insert menu, entity autocompletes) must come after it to keep
 * handling Enter while a popup is open.
 */
import { keydownHandler } from "prosemirror-keymap";
import { Plugin } from "prosemirror-state";

import { BaseExtension } from "@/wc/text-editor/lib/core/base-extension";
import { dispatchHostEvent } from "@/wc/text-editor/lib/core/plugins/host-events";

const submitOnEnterPlugin = () =>
    new Plugin({
        props: {
            handleKeyDown: keydownHandler({
                Enter: (state) => {
                    dispatchHostEvent(state, "submit");
                    return true;
                },
            }),
        },
    });

export class SubmitOnEnterExtension extends BaseExtension {
    plugins = () => [submitOnEnterPlugin()];
}
